export { default, default as SimpleBadge } from './SimpleBadge'
export { default as simpleBadgeTheme } from './themes/SimpleBadge.theme'
export * as SimpleBadgeStyles from './styles/SimpleBadge.style'

export type { SimpleBadgeProps } from './SimpleBadge.types'
export type { AppearanceKeys, SimpleBadgeTheme } from './themes/SimpleBadge.theme.types'
export type { StyledSimpleBadgeProps } from './styles/SimpleBadge.style.types'
